import React from 'react';
import Loading from './loading';

const overlayStyle = {
    position: 'absolute',
    top: '0px',
    bottom: '0px',
    left: '0px',
    right: '0px',
    backgroundColor: '#fff',
    zIndex: '9999',
    opacity: '0.4',
};

function PanelLoading(props) {
    const { loading = true } = props;
    return (
        <div style={overlayStyle}>{loading && <Loading />}</div>
    );
}

export default PanelLoading;


// WEBPACK FOOTER //
// ./src/components/panelLoading.jsx